<div role="main" class="fc-page">
  <app-header></app-header>
  <app-progress-bar [currentStep]="3"></app-progress-bar>
  <app-meta-bar [referenceId]="service.referenceFileDetails.referenceId || service.getCache('referenceId')"></app-meta-bar>

  <section class="fc-panel">
    <div class="fc-panel-header">
      <h2>Routing</h2>
    </div>
    <div class="fc-panel-body">
      <p class="fc-instructions">Please select the documentation request category you are responding to per the communication sent to you.</p>

      <div class="routing-options-group" [class.required]="!selectedRoutingOption">
        @if (showMedicalRecords) {
          <label class="routing-option" [class.selected]="selectedRoutingOption === 'Medical Records Request'">
            <input type="radio" name="routingOption" value="Medical Records Request" [(ngModel)]="selectedRoutingOption">
            <span>
              <strong>Medical Records Request</strong>
              <small>Responding to a request for patient medical records related to a claim review.</small>
            </span>
          </label>
        }

        @if (showAppeals) {
          <label class="routing-option" [class.selected]="selectedRoutingOption === 'Appeal / Reconsideration'">
            <input type="radio" name="routingOption" value="Appeal / Reconsideration" [(ngModel)]="selectedRoutingOption">
            <span>
              <strong>Appeal / Reconsideration</strong>
              <small>Submitting documentation to support an appeal or reconsideration of a determination.</small>
            </span>
          </label>
        }

        @if (showOverpayment) {
          <label class="routing-option" [class.selected]="selectedRoutingOption === 'Overpayment Acknowledgment'">
            <input type="radio" name="routingOption" value="Overpayment Acknowledgment" [(ngModel)]="selectedRoutingOption">
            <span>
              <strong>Overpayment Acknowledgment</strong>
              <small>Upload acknowledgment to an overpayment.</small>
            </span>
          </label>
        }

        @if (!showMedicalRecords && !showAppeals && !showOverpayment) {
          <div class="alert alert-warning">No routing options are currently enabled.</div>
        }
      </div>
    </div><!-- end fc-panel-body -->

    <div class="fc-panel-footer fc-panel-footer-between">
      <div class="fc-footer-left">
        <!-- <button type="button" class="btn-secondary-action" (click)="back()">Back</button> -->
        <button type="button" class="btn-secondary-action ms-2" (click)="startOver()">Start Over</button>
      </div>
      <button type="button" class="btn-enter" (click)="continue()" [disabled]="!selectedRoutingOption">Continue &gt;</button>
    </div>
  </section>

  <app-footer [positionFixed]="false"></app-footer>
</div>
